var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 2.66536C5.05513 2.66536 2.66732 5.05318 2.66732 7.9987C2.66732 10.9442 5.05513 13.332 8.00065 13.332C10.9462 13.332 13.334 10.9442 13.334 7.9987C13.334 5.05318 10.9462 2.66536 8.00065 2.66536ZM1.33398 7.9987C1.33398 4.3168 4.31875 1.33203 8.00065 1.33203C11.6825 1.33203 14.6673 4.3168 14.6673 7.9987C14.6673 11.6806 11.6825 14.6654 8.00065 14.6654C4.31875 14.6654 1.33398 11.6806 1.33398 7.9987Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4951 8.10327C11.4951 8.47146 11.1966 8.76993 10.8284 8.76993L7.72386 8.76993C7.35567 8.76993 7.05719 8.47146 7.05719 8.10327L7.05719 5.55098C7.05719 5.18279 7.35567 4.88432 7.72386 4.88432C8.09205 4.88432 8.39052 5.18279 8.39052 5.55098L8.39052 7.4366L10.8284 7.4366C11.1966 7.4366 11.4951 7.73508 11.4951 8.10327Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.3ec836f5e7392071b343fec68a75377a.svg";
export { ForwardRef as ReactComponent };